import { School } from '../school';
import { ClassType } from '../class-type';
import { Student } from '../student';
import { Reservation } from '../reservation';
import { Card } from '../card';
import { Location } from '../location';

export const enum LessonStatus {
    'OPEN',
    'EXECUTED',
    'CANCELLED'

}

export class Lesson {
    public currentStudentReservation: Reservation;
    public currentStudentCard: Card;
    public availablePlaces: number;
    public bookings: number;
    constructor(
        public id?: number,
        public begining?: any,
        public ending?: any,
        public maxParticipants?: number,
        public reservationCancellationPolicy?: number,
        public reminderPolicy?: number,
        public status?: LessonStatus,
        public minParticipants?: number,
        public school?: School,
        public classType?: ClassType,
        public teacher?: Student,
        public location?: Location,
        public free?: boolean,
        public videoConference?: boolean,
        public published?: boolean,
        public videoConferenceUrl?: string,
        public paymentIntentUrl?: string,
        public planningTag?: string
    ) {
    }
}

export class LessonAvailability {
    constructor(public lessonId?: number, public availablePlaces?: number) {

    }
}

export class LessonBulkCreateInput {
    constructor(
        public lesson: Lesson,
        public toDate: any,
        public createInUnavailableDates: boolean,
        public createInMondays: boolean,
        public createInTuesdays: boolean,
        public createInWednesdays: boolean,
        public createInThursdays: boolean,
        public createInFridays: boolean,
        public createInSaturdays: boolean,
        public createInSundays: boolean
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.model.ts